/** @jsx jsx */
import {jsx} from 'theme-ui'
import Button from './Button'
import {Trans, useTranslation} from 'react-i18next'
import DonateNowButton from './DonateNowButton'
type Props = {
  className?: string
}
const HomeCTA: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  return (
    <section
      id="home__cta"
      className={className}
      sx={{
        mt: [50, , 118],
        width: ['100%', '90%', 1028],
        mx: 'auto',
        borderRadius: [, 13],
        bg: '#F0F5F7',
        pt: [48, , 67],
        pb: [48, , 53],
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <h2
        sx={{
          fontFamily: ['Lato', , 'Lato Medium'],
          fontSize: [28, , 32],
          fontWeight: [600, , 400],
          my: 0,
        }}
      >
        {t('CTATitle')}
      </h2>
      <p
        sx={{
          mt: 10,
          mb: 0,
          fontSize: [18, , 16],
          width: [300, , 'auto'],
          maxWidth: ['95%'],
          lineHeight: '24px',
          color: 'soft',
        }}
      >
        <Trans i18nKey="CTAText">
          Support the cause you believe in and be&nbsp;
          <span
            sx={{
              fontWeight: 600,
              color: 'black',
            }}
          >
            With Humanity. Everywhere.
          </span>
        </Trans>
      </p>
      <DonateNowButton
        sx={{
          mt: [18, , 32],
          py: 17,
          px: 34,
        }}
      />
    </section>
  )
}

export default HomeCTA
